import React from 'react';
import useMyServicesHook from './myServices-hook';
import { ICompanyResponse } from '../../../../../../../Interfaces/responseTypes';
import useLanguagesHooks from '../../../../../../../Components/Languages/setLanguage-hooks';
import ToggleSwitch from '../../../../../../../Components/ToggleSwitch/toggleSwitch';
import AuthInput from '../../../../../../../Components/Inputs/AuthInput/authInput';
import Button from '../../../../../../../Components/Button/button';
import { ButtonTypes } from '../../../../../../../Interfaces/componentTypes';
import DineInUnits from './DineInUnits/dineInUnits';
import styles from './myServices.module.scss';

export interface IMyServicesProps {
    data: ICompanyResponse;
    onUpdate: () => void
};

const MyServices: React.FC<IMyServicesProps> = (props) => {
    const { t } = useLanguagesHooks();
    const {
        onSave,
        register,
        errors,
        control,
        updateLoadng,
        createLoading,
        deliveryActive,
        dineInActive,
        dineInUnits,
        onDineInUnitsChange,
        isButtonActive,
    } = useMyServicesHook(props);

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <p>
                    {t('My_Business.My_Services.Header')}
                </p>
            </div>
            <div className={styles.form}>
                <div className={styles.formItem}>
                    <p>{t('My_Business.My_Services.Delivery')}</p>
                    <ToggleSwitch
                        name="delivery.is_active"
                        control={control}
                    />
                </div>
                {deliveryActive && (
                    <div className={styles.inputItem}>
                        <p>{t('My_Business.My_Services.Min_Cost')}</p>
                        <AuthInput
                            register={register}
                            registerName='delivery.min_cost'
                            error={errors.delivery?.min_cost}
                            type='number'
                            required={true}
                            minDate='1'
                            showTextError={false}
                            inputStyle={styles.input}
                            inputBoxStyles={styles.inputBox}
                        />
                    </div>
                )}
                <div className={styles.formItem}>
                    <p>{t('My_Business.My_Services.Pre_Order')}</p>
                    <ToggleSwitch
                        name="pre_order"
                        control={control}
                    />
                </div>
                <div className={styles.formItem}>
                    <p>{t('My_Business.My_Services.Reserve')}</p>
                    <ToggleSwitch
                        name="reserve"
                        control={control}
                    />
                </div>
                <div className={styles.formItem}>
                    <p>{t('My_Business.My_Services.Dine_In.Title')}</p>
                    <ToggleSwitch
                        name="dine_in.is_active"
                        control={control}
                    />
                </div>
                {dineInActive && (
                    <div className={styles.dineInContainer}>
                        <DineInUnits
                            units={dineInUnits}
                            onUnitsChange={onDineInUnitsChange}
                        />
                    </div>
                )}
                <div className={styles.buttonRow}>
                    {
                        isButtonActive
                        &&
                        <Button
                            title={t('Buttons.Save')}
                            type='button'
                            buttonType={ButtonTypes.Primery}
                            buttonStyle={`${styles.button}`}
                            buttonTitleStyle={styles.buttonTitle}
                            onClick={onSave}
                            isLoading={updateLoadng || createLoading}
                            loadingSize='12'
                        />
                    }
                </div>
            </div>
        </div>
    )
}

export default MyServices
